import { render, staticRenderFns } from "./UsuarioGet.vue?vue&type=template&id=ac0f3fc8&scoped=true"
import script from "./UsuarioGet.vue?vue&type=script&lang=js"
export * from "./UsuarioGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0f3fc8",
  null
  
)

export default component.exports